<template>
    <div class="wrap">
        <div class="kv">
        </div>
        <div class="title">
            <h1>{{title}}</h1>
        </div>
        <div class="login-wrap">
            <input type="text" class="name" placeholder="姓名" v-model="name">
            <input type="text" class="phone" placeholder="手机号" v-model="phone">
            <span class="submit" @click="docLogin">{{submit}}</span>
        </div>
    </div>
</template>

<script>

    import {wLogin} from "@/assets/js/api";
    import {checkMobile} from "@/assets/util/util";

    export default {
        name: '',
        data() {
            return {
                title:"请登录账号",
                submit: "登录",
                name: "",
                phone: "",
                openId :  this.$store.state.openId
            }
        },
        methods: {
            async docLogin() {
                if(!this.name){
                    this.$toast("请填写姓名")
                    return
                }
                if(!this.phone){
                    this.$toast("请填写手机号")
                    return
                }

                // 验证手机号格式
                if (!checkMobile(this.phone)) {
                    this.$toast("手机号不正确");
                    return false;
                }
                let name = this.name;
                let phone = this.phone;
                // let openId = this.openId
                const res = await wLogin({name, phone})
                if(res.data.success==true){
                    this.$store.state.docId = res.data.data.docId
                    if(res.data.success==true){
                        this.$store.commit("setDocId",res.data.data.docId)
                        let agree = res.data.data.agree
                        if(agree==1){
                            this.$router.push({path:"wx_index"})
                        }else{
                            this.$router.push({path:"wx_agree"})
                        }
                    }else{
                        this.$toast("登录失败")
                        // this.$router.push({path:"case"})
                    }
                }else {
                    this.$toast(res.data.message)
                }
                console.log(res)
            },
            // async docLoginByOpenId(openId){
            //         const res = await loginByOpenId({openId})
            //
            //         if(res.data.data.station!=1){
            //             return
            //         }
            //
            //         this.$store.state.docId = res.data.data.docId
            //         if(res.data.success==true){
            //             this.$router.push({path:"case"})
            //         }
            // }
        },
        mounted(){
            // if(this.openId!=''&&this.openId!=null){// 用openid登录
            //     this.docLoginByOpenId(this.openId)
            // }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .wrap {
        width: 100%;
        max-width: 500px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background: #FFF;
        margin: 0 auto;
        overflow: auto;
    }

    .login-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /*margin-top: 10px;*/
    }

    input {
        width: 70%;
        height: 35px;
        margin-top: 10px;
        border-radius: 20px;
        text-indent: 10px;
        outline: none;
        border: #0082C5 solid 1px;
        font-size: 15px;
    }

    .submit {
        width: 70%;
        height: 30px;
        line-height: 30px;
        background: red;
        margin-top: 10px;
        border-radius: 10px;
        color: #FFF;
        font-size: 20px;
        background: #0082C5;
    }


    .title{
        /*margin-top: 100px;*/
        color: #0082C5;
        h1{
            font-size: 30px;
        }
    }

    .kv{
        width: 100%;
        /*height: 100vw;*/
        padding: 56.25% 0 0;
        background: #FFF url("../../assets/img/wx_kv.jpg") no-repeat;
        background-size: 100% 100% ;
    }
</style>
